import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod/v4";

export const getRedoSuppliesOrderFulfillmentGroups = {
  name: "getRedoSuppliesOrderFulfillmentGroups" as const,
  input: z.object({ orderId: z.string() }),
  output: z.object({ fulfillmentGroups: z.array(FulfillmentGroupDataSchema) }),
};
